import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=4776eb9f&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=ts&"
export * from "./normal.vue?vue&type=script&lang=ts&"
import style0 from "./normal.vue?vue&type=style&index=0&id=4776eb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776eb9f",
  null
  
)

export default component.exports